export default __webpack_public_path__ + "static/media/GaugeImg6.c15d045b.jpg";